import { render, staticRenderFns } from "./JournalsSearch.vue?vue&type=template&id=25419590&"
import script from "./JournalsSearch.vue?vue&type=script&lang=js&"
export * from "./JournalsSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports